import React, { Component } from 'react'
import TimePicker from "../../components/TimePicker.js/TimePicker";
import { Navigate } from 'react-router-dom';
import SwalServices from '../../services/swalServices/SwalServices';
import SGTechTVServices from '../../services/axiosServices/apiServices/SGTechTVServices';
import CommonServices from '../../services/axiosServices/apiServices/CommonServices';
import moment from 'moment';
import ValidationText from '../../utils/validation/ValidationText';
import ImageCropperWithUpload from '../../components/ImageUpload/UploadImage';
import { components } from 'react-select';
import { CommonValidationMessages, ErrorMessage, SuccessMessage } from "../../utils/Messages";
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown';
import ResourceServices from '../../services/axiosServices/apiServices/ResourceServices';
import ToggleButton from '../../components/common/ToggleButton';
import { checkParameters } from '../../utils/Encryption';
import CKClassicEditor from '../../components/CKEditorComponent/CKEditorComponent';
import ButtonLoader from '../../components/common/buttonLoader/ButtonLoader';

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

export default class UploadSGTechTV extends Component {
    constructor(props) {
        super(props)
        this.sgtechServices = new SGTechTVServices();
        this.commonServices = new CommonServices();
        this.swalServices = new SwalServices();
        this.ResourceServices = new ResourceServices();
        this.state = {
            redirect: null,
            route: null,
            isLoading: false,
            isUploading: false,
            sgTechTVId: 0,
            sgTechTVItem: {
                sgTechTVId: 0,
                videoTitle: "",
                description: "",
                uploadThumbnailPath: "",
                videoEmbedLink: "",
                videoFilePath: "",
                //sgTechTVCategoryId: 0,
                topicIds: 0,
                SGTechTVVisibilityId: 1,
                sgTechTVStatusId: 0,
                sgTechTVPublishDate: moment(new Date().toLocaleDateString()).format("ddd, DD MMM yyyy"),
                sgTechTVPublishTime: "12:00 AM",
                isFeatured: false,
                member: true,
                nonMember: false,
                isPublishNow: false,
                isSchedule: true,
                optionSelected: [],
                videoValidation: true,
            },
            sgTechTopics: [],
            checkFeatured: false,
            categoryList: [],
            validationRule: {
                videoTitle: [
                    {
                        type: 'require',
                        message: CommonValidationMessages.FieldRequired.replace('{0}', 'video title')
                    }
                ],
                sgTechTVPublishDate: [
                    {
                        type: 'require',
                        message: CommonValidationMessages.SelectRequired.replace('{0}', 'publish date')
                    }
                ],
                sgTechTVPublishTime: [
                    {
                        type: 'require',
                        message: CommonValidationMessages.SelectRequired.replace('{0}', 'time')
                    }
                ],
                optionSelected: [
                    {
                        type: 'require',
                        message: CommonValidationMessages.SelectRequired.replace('{0}', ' topic')
                    }
                ],
            },
            validState: {
                isValid: true,
                error: {}
            },
        };
    }

    // Method declaration section
    componentDidMount() {
        let params = new URLSearchParams(window.location.search);
        let sgTechTVId = params.get("");

        if (sgTechTVId && (sgTechTVId = checkParameters(sgTechTVId, "Number"))) {
            if (sgTechTVId > 0) {
                this.setState({ sgTechTVId: sgTechTVId }, () => this.getAllTopics());
            }
            else {
                this.getAllTopics();
            }
        } else {
            this.getAllTopics();
        }
    }

    sgTechTVFeaturedCheck = () => {
        this.sgtechServices.sgTechTVFeaturedCheck().then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                this.setState({ checkFeatured: response.responseItem.responseContent.isFeatured });
            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        }).catch(() => {
            this.swalServices.Error("Something went wrong. Please try again.");
        })
    }

    getSGTechTVById = (id) => {
        this.sgtechServices.getSGTechTVById(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                let detail = this.state.sgTechTVItem;
                if (response.responseItem.responseContent.sgTechTVVisibilityId === 4) {
                    detail.member = true;
                    detail.nonMember = false;
                } else if (response.responseItem.responseContent.sgTechTVVisibilityId === 5) {
                    detail.nonMember = true;
                    detail.member = false;
                }
                if (response.responseItem.responseContent.isPublishNow === true) {
                    detail.isPublishNow = true;
                    detail.isSchedule = false;

                } else if (response.responseItem.responseContent.isPublishNow === false) {
                    detail.isSchedule = true;
                    detail.isPublishNow = false;
                }

                detail.sgTechTVPublishDate = response.responseItem.responseContent.sgTechTVPublishDate;
                detail.sgTechTVPublishTime = response.responseItem.responseContent.sgTechTVPublishTime;
                detail.sgTechTVId = response.responseItem.responseContent.sgTechTVId;
                detail.videoTitle = response.responseItem.responseContent.videoTitle;
                detail.description = response.responseItem.responseContent.description;
                detail.videoEmbedLink = response.responseItem.responseContent.videoEmbedLink;
                detail.videoFilePath = response.responseItem.responseContent.videoFilePath;
                detail.uploadThumbnailPath = response.responseItem.responseContent.uploadThumbnailPath;
                detail.sgTechTVCategoryId = response.responseItem.responseContent.sgTechTVCategoryId;
                detail.isFeatured = response.responseItem.responseContent.isFeatured;

                var array = response.responseItem.responseContent.topicIds.split(',');
                const options = [];
                array.forEach(topic => {
                    options.push(this.state.sgTechTopics.find(topics => topics.value === Number(topic)));
                });
                detail.optionSelected = options;
                this.setState({ sgTechTVItem: detail });

            } else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        }).catch(() => {
            this.swalServices.Error("Something went wrong. Please try again.");
        })
    }

    getAllSGTechTVCategory = () => {
        this.sgtechServices.getAllSGTechTVCategory().then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                this.setState({ categoryList: response.responseItem.responseContent });
            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        }).catch(() => {
            this.swalServices.Error("Something went wrong. Please try again.");
        })
    }

    addEditSGTechTv = (id) => {
        if (this.state.isUploading) return;

        let detail = this.state.sgTechTVItem;
        if (detail['member'] === true) {
            detail['SGTechTVVisibilityId'] = 4;
        }
        else {
            detail['SGTechTVVisibilityId'] = 5;
        }
        if (detail['isPublishNow'] === true) {
            detail['isPublishNow'] = true;
            if (this.state.sgTechTVId > 0) {

            } else {
                detail['sgTechTVPublishDate'] = moment(new Date()).format("YYYY-MM-DD");
                detail['sgTechTVPublishTime'] = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            }
        }
        else {
            detail['isPublishNow'] = false;
        }
        if (id > 0) {
            detail['sgTechTVStatusId'] = id;
        }

        if (detail.optionSelected.length > 0) {
            var arr1 = this.state.sgTechTVItem.optionSelected.map(function (item) {
                delete item.bad;
                return item.value;
            });
            detail.topicIds = arr1.join([',']);
        }

        this.setState({ sgTechTVItem: { ...detail } });
        let request = this.state.sgTechTVItem;
        let isValidInput = this.isValidateAllFields()
        if (isValidInput) {
            this.setState({ isLoading: true })
            this.sgtechServices.addEditSGTechTv(request).then(
                (response) => {
                    if (response.statusCode === 200 && response.responseItem != null) {
                        if (response.responseItem.responseContent.errorType === "EXISTS") {
                            this.swalServices.Warning(ErrorMessage.Already_Exist.replace("{0}", "SGTech TV details"));
                        }
                        else {
                            this.swalServices.Success(
                                SuccessMessage.Insert_Success.replace("{0}", "Your SGTech TV details"));
                            this.setState({ redirect: "/SGTechTV" });
                        }
                    } else {
                        this.swalServices.Error(ErrorMessage.DefaultMessage);
                    }
                    this.setState({ isLoading: false });
                }
            ).catch(() => {
                this.setState({ isLoading: false });
                this.swalServices.Error("Something went wrong. Please try again.");
            });
        }
    };

    handleVideoEmbedLinkBlur = () => {
        const value = this.state.sgTechTVItem.videoEmbedLink;
        const embedUrlFormate = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/((\w|-){11})(?:\S+)?$/;
        const urlFormate = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?(?=.*v=((\w|-){11}))(?:\S+)?$/;
        if (value && value !== "") {
            let detail = { ...this.state.sgTechTVItem };
            if (value.match(urlFormate)) {
                let splitUrl = value.split("=");
                let embedUrl = `https://www.youtube.com/embed/${splitUrl[1]}`;
                if (embedUrl.includes("&")) {
                    let splitParts = embedUrl.split("&");
                    embedUrl = splitParts[0];
                }
                detail["videoEmbedLink"] = embedUrl;
                this.setState({ sgTechTVItem: detail });
            } else if (value.match(embedUrlFormate)) {
                this.setState({ sgTechTVItem: detail });
            }
            else {
                this.swalServices.Error("Please enter valid video link.");
            }
        }
        this.validateField("videoEmbedLink");
    }

    isValidateAllFields = () => {
        const { videoEmbedLink, videoFilePath } = this.state.sgTechTVItem;
        let newValidState = { ...this.state.validState };

        // Check if both fields are empty
        if (!videoEmbedLink && !videoFilePath) {
            newValidState.error.videoEmbedLink = "Please provide either a Video Embed Link or Upload a Video.";
            newValidState.error.videoFilePath = "Please provide either a Video Embed Link or Upload a Video.";
            newValidState.isValid = false;
        } else {
            // Run the existing validation rules
            newValidState = isValidForm(this.state.sgTechTVItem, this.state.validationRule, this.state.validState);
        }

        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    validateField = (key) => {
        const { videoEmbedLink, videoFilePath } = this.state.sgTechTVItem;
        let newValidState = { ...this.state.validState };

        if (!videoEmbedLink && !videoFilePath) {
            newValidState.error.videoEmbedLink = "Please provide either a Video Embed Link or Upload a Video.";
            newValidState.error.videoFilePath = "Please provide either a Video Embed Link or Upload a Video.";
        } else {
            if (this.state.validationRule[key]) {
                newValidState = validate(key, this.state.sgTechTVItem, this.state.validationRule, this.state.validState);
            }
        }

        this.setState({ validState: newValidState });
    };

    getAllTopics = () => {
        this.ResourceServices.getAllResourceTopics().then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                this.setState({ sgTechTopics: response.responseItem.responseContent });
                if (this.state.sgTechTVId > 0) {
                    this.getSGTechTVById(this.state.sgTechTVId)
                }
            }
            else {
                if (this.state.sgTechTVId > 0) {
                    this.getSGTechTVById(this.state.sgTechTVId)
                }
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        }).catch(() => {
            this.swalServices.Error("Something went wrong. Please try again.");
        })
    }


    handleChangeInDropdown = selected => {
        var res = this.state.sgTechTVItem;
        res.optionSelected = selected
        this.setState({ sgTechTVItem: res });
        this.validateField("optionSelected");
    };

    saveMainImage = (file, keyId, imageIdentity) => {
        file.storagePath = imageIdentity
        this.setState({ isUploading: true });
        this.commonServices.storeBase64Image(file).then((response) => {
            if (response != null) {
                this.swalServices.Success("File Uploaded");
                let detail = this.state.sgTechTVItem;
                if (file.storagePath === "SGTechTV") {
                    detail["uploadThumbnailPath"] = response.fileName;
                    this.setState({ sgTechTVItem: { ...detail } },
                    );
                }
            }
            else {
                this.swalServices.Error("Something went wrong. Please try again.");
            }
            this.setState({ isUploading: false });
        }).catch(() => {
            this.setState({ isUploading: false });
            this.swalServices.Error("Something went wrong. Please try again.");
        })
    }

    handleRadioButtons(event) {
        const value = event.target.checked;
        const id = event.target.id;
        let detail = this.state.sgTechTVItem;
        detail['member'] = false;
        detail['nonMember'] = false;
        detail[id] = value;
        this.setState({ sgTechTVItem: { ...detail } });
    }
    handleRadioButtons2(event) {
        const value = event.target.checked;
        const id = event.target.id;
        let detail = this.state.sgTechTVItem;
        detail['isPublishNow'] = false;
        detail['isSchedule'] = false;
        detail[id] = value;
        this.setState({ sgTechTVItem: { ...detail } });
    }

    setTime = (time) => {
        let detail = this.state.sgTechTVItem;
        if (time.identity === "PublishTime") {
            detail['sgTechTVPublishTime'] = time.selectedTime;
        }
        this.setState({ sgTechTVItem: { ...detail } });
    }

    filterByFeatured = (value, e) => {
        let detail = this.state.sgTechTVItem;
        this.setState({ setToggle: e.target.checked });
        detail.isFeatured = e.target.checked;
        this.setState({ sgTechTVItem: { ...detail } });
    };


    handleChange(event) {
        const value = event.target.value;
        const name = event.target.name;
        let detail = this.state.sgTechTVItem;
        detail[name] = value;
        this.setState({ sgTechTVItem: { ...detail } });
    }

    setVideoDescription = (data) => {
        let detail = this.state.sgTechTVItem;
        var re = new RegExp("<a href=\"([^\"]+)\"", "g");
        var result = data.replace(re, "<a href='$1' target=\"_blank\" rel=\"noopener noreferrer\"");
        detail["description"] = result;
        this.setState({ sgTechTVItem: { ...detail } });
    };

    handleVideoEditorChange(event, editor) {
        const data = editor.getData();
        this.setVideoDescription(data);
    }

    back = () => {
        this.setState({ redirect: "/SGTechTV" });
    }

    onFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const validVideoTypes = "video/mp4";

        let request = {};
        request.key = "mol@123";
        request.filePath = file;
        request.folder = "sgtech-videos";

        if (validVideoTypes) {
            this.setState({ isUploading: true });
            this.commonServices.uploadVideoToS3Bucket(request).then((response) => {
                if (response?.fileName) {
                    let detail = { ...this.state.sgTechTVItem };
                    detail.videoFilePath = response.fileName;
                    this.setState({ sgTechTVItem: detail });
                    this.swalServices.Success("File Uploaded Successfully!");
                } else {
                    this.swalServices.Error("Upload Failed: " + (response?.message || "Something went wrong. Please try again."));
                }
                this.setState({ isUploading: false });
            }).catch(() => {
                this.setState({ isUploading: false });
                this.swalServices.Error("Something went wrong. Please try again.");
            });
        }
        else {
            this.swalServices.Warning("Upload Video of mp4 type only.");
        }
    };


    render() {
        if (this.state.redirect != null) {
            return <Navigate to={this.state.redirect} />;
        }
        return (
            <div className='main-body-section'>

                <div className='bg-white'>
                    <div className='heading-part px-7 py-4 border-b'>
                        <h4 className='text-2xl font-bold theme-color'>Video Information</h4>
                    </div>
                    <div className="px-14 py-4">
                        <div className='my-5'>
                            <div className='grid grid-cols-12 max-lg:grid-cols-1 gap-6 '>
                                <div className='xl:col-span-8 col-span-8'>
                                    <div className='grid grid-cols-12 max-lg:grid-cols-1 max-lg:pr-0 pr-14 gap-6 max-lg:gap-3'>
                                        <div className=' xl:col-span-8  col-span-8'>
                                            <label className="block text-xl font-normal mb-3 theme-color min-h-30" htmlFor="default">Title<span className='text-[#C00000]'>*</span></label>
                                            <input
                                                id="default"
                                                className="form-input rounded-none w-full shadow-red py-3 text-lg"
                                                type="text"
                                                name="videoTitle"
                                                value={this.state.sgTechTVItem.videoTitle}
                                                onChange={(event) => this.handleChange(event)}
                                                onBlur={this.handleVideoEmbedLinkBlur}
                                            />
                                            <div>
                                                <ValidationText error={this.state.validState.error.videoTitle} />
                                            </div>
                                        </div>
                                        <div className=' xl:col-span-12 col-span-12 mt-5'>
                                            <label className="block text-xl font-normal mb-3 theme-color min-h-30" htmlFor="default">Description <span className='text-[#C00000]'>*</span></label>
                                            <div className="ck-editor-sec">
                                                <CKClassicEditor
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        this.setVideoDescription(data);
                                                    }}
                                                    data={this.state.sgTechTVItem.description}
                                                />
                                                {(!this.state.sgTechTVItem.description) ?
                                                    <ValidationText
                                                        error={"Please enter description"}
                                                    />
                                                    :
                                                    null
                                                }
                                            </div>
                                        </div>

                                    </div>
                                    <div className='grid grid-cols-12 pr-14 mt-10 gap-6 max-lg:grid-cols-1 max-lg:pr-0 max-lg:gap-3 max-lg:mt-5 items-center'>
                                        <div className=' xl:col-span-5 col-span-5'>
                                            <div className="flex items-center space-x-2  mb-4">
                                                <label className="block text-xl font-normal theme-color" htmlFor="default">Video Embed Link</label>
                                                <div className="video-tooltip-sec">
                                                    <img className="w-[25px]" src="/tooltip.png" alt="" />
                                                    <div className="tool-tip ml-5">
                                                        <div className="tool-tip-inner">
                                                            <div className="popover-heading font-bold">
                                                                Instruction
                                                            </div>
                                                            <div className="popover-body">
                                                                <p>
                                                                    <strong>1.</strong> On a computer, go to the YouTube video you
                                                                    want to embed.
                                                                </p>
                                                                <p>
                                                                    <strong>2.</strong> Copy Browser Link and Paste.
                                                                    (e.g.https://www.youtube.com/watch?v=Ke90Tje7VS0)
                                                                </p>
                                                                <p>
                                                                    <strong>3.</strong> Link will be Automatically convert into
                                                                    embed url
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <input
                                                id="default"
                                                name="videoEmbedLink"
                                                className="form-input rounded-none w-full shadow-red py-3 text-lg"
                                                type="text"
                                                placeholder=""
                                                value={this.state.sgTechTVItem.videoEmbedLink}
                                                onChange={(event) => this.handleChange(event)}
                                                onBlur={this.handleVideoEmbedLinkBlur}
                                            />
                                            <div>
                                                {!this.state.sgTechTVItem.videoEmbedLink ? (
                                                    <ValidationText error={this.state.validState.error.videoEmbedLink} />
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className=' xl:col-span-2 col-span-2 text-center'>
                                            <span className='text-2xl theme-color'>Or</span>
                                        </div>
                                        <div className='xl:col-span-5 col-span-5 '>
                                            <div className="flex items-center space-x-2  mb-4">
                                                <label className="block text-xl font-normal theme-color" htmlFor="default">Upload Video</label>
                                            </div>
                                            <input
                                                type="file"
                                                accept="video/mp4, video/mov, video/avi, video/mkv"
                                                className="hidden"
                                                id="videoUpload"
                                                onChange={this.onFileChange}
                                                onBlur={() => this.validateField("videoFilePath")}
                                            />
                                            <button
                                                className="px-5 w-full py-2 btn-red-border text-xl border text-[#C00000] input-red-btn"
                                                onClick={() => document.getElementById("videoUpload").click()}
                                            >
                                                Upload Video
                                            </button>
                                            <span>{this.state.sgTechTVItem.videoFilePath ? this.state.sgTechTVItem.videoFilePath : null}</span>
                                        </div>
                                    </div>
                                    <div className='grid grid-cols-12 pr-14  mt-10 gap-6 max-lg:grid-cols-1 max-lg:pr-0 max-lg:mt-5'>
                                        <div className=' xl:col-span-7 col-span-7'>
                                            <label className="block text-xl font-normal mb-3 theme-color min-h-30" htmlFor="default">
                                                Topics
                                                <span className='text-[#C00000]'>*</span>
                                            </label>
                                            <MultiSelectDropdown
                                                options={this.state.sgTechTopics}
                                                isMulti
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                components={{
                                                    Option,
                                                }}
                                                onChange={this.handleChangeInDropdown.bind(this)}
                                                allowSelectAll={true}
                                                value={this.state.sgTechTVItem.optionSelected}
                                            />
                                            <div>

                                                {this.state.sgTechTVItem.optionSelected ?
                                                    <ValidationText error={this.state.validState.error.optionSelected} />
                                                    :
                                                    null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className='grid pr-14 mt-10 max-lg:mt-5'>
                                        <ToggleButton
                                            label="Featured"
                                            setToggle={this.state.sgTechTVItem.isFeatured}
                                            onHandleToggle={this.filterByFeatured.bind(this)}
                                            index={0}
                                        />
                                    </div>

                                    <div className='grid grid-cols-12 pr-14  mt-8 gap-6 max-lg:grid-cols-1 max-lg:pr-0'>
                                        <div className=' xl:col-span-7 col-span-7'>
                                            <label className="block text-xl font-normal mb-3 theme-color min-h-30" htmlFor="default">Access<span className='text-[#C00000]'>*</span></label>
                                            <div className='grid grid-cols-12 pr-14  gap-6 max-lg:grid-cols-2 max-lg:pr-0'>
                                                <div className=' xl:col-span-6 col-span-6'>
                                                    <label className="flex items-center">
                                                        <input
                                                            type="radio"
                                                            name="member"
                                                            id="member"
                                                            className="form-radio"
                                                            value={this.state.sgTechTVItem.member}
                                                            onChange={(event) =>
                                                                this.handleRadioButtons(event)
                                                            }
                                                            checked={this.state.sgTechTVItem.member === true}
                                                        />
                                                        <span className="text-xl  font-normal theme-color ml-2">Member</span>
                                                    </label>
                                                </div>
                                                <div className=' xl:col-span-6 col-span-6'>
                                                    <label className="flex items-center">
                                                        <input
                                                            type="radio"
                                                            name="nonMember"
                                                            id="nonMember"
                                                            className="form-radio"
                                                            value={this.state.sgTechTVItem.nonMember}
                                                            onChange={(event) =>
                                                                this.handleRadioButtons(event)
                                                            }
                                                            checked={this.state.sgTechTVItem.nonMember === true}
                                                        />
                                                        <span className="text-xl whitespace-nowrap font-normal theme-color ml-2">Non-Member</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='grid grid-cols-12 pr-14  mt-10 gap-6 max-lg:grid-cols-1 max-lg:pr-0 max-lg:mt-5'>
                                        <div className=' xl:col-span-7 col-span-7'>
                                            <label className="block text-xl font-normal mb-3 theme-color min-h-30" htmlFor="default">Publish Date & Time <span className='text-[#C00000]'>*</span></label>
                                            <div className='grid grid-cols-12 pr-14  gap-6 max-lg:grid-cols-2 max-lg:pr-0'>
                                                <div className=' xl:col-span-6 col-span-6'>
                                                    <label className="flex items-center">
                                                        <input
                                                            type="radio"
                                                            name="publish-now"
                                                            id="isPublishNow"
                                                            className="form-radio"
                                                            value={this.state.sgTechTVItem.isPublishNow}
                                                            onChange={(event) =>
                                                                this.handleRadioButtons2(event)
                                                            }
                                                            checked={this.state.sgTechTVItem.isPublishNow === true}
                                                        />
                                                        <span className="text-xl  font-normal whitespace-nowrap theme-color ml-2">Publish Now</span>
                                                    </label>
                                                </div>
                                                <div className=' xl:col-span-6 col-span-6'>
                                                    <label className="flex items-center">
                                                        <input
                                                            type="radio"
                                                            name="schedule-now"
                                                            id="isSchedule"
                                                            className="form-radio"
                                                            value={this.state.sgTechTVItem.isSchedule}
                                                            onChange={(event) =>
                                                                this.handleRadioButtons2(event)
                                                            }
                                                            checked={this.state.sgTechTVItem.isSchedule === true}
                                                        />
                                                        <span className="text-xl  font-normal theme-color ml-2">Schedule</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.sgTechTVItem.isPublishNow === true ?
                                        null
                                        :
                                        <div className='grid grid-cols-12 pr-14  mt-7 gap-6 max-lg:grid-cols-1 max-lg:pr-0'>
                                            <div className=' xl:col-span-9 col-span-9'>
                                                <div className='grid grid-cols-12 gap-6 items-center w-full max-lg:grid-cols-1 max-lg:p-0 max-lg:gap-3'>
                                                    <div className=' xl:col-span-6 col-span-6 w-full max-lg:pr-0'>
                                                        <label className="block text-xl font-normal mb-3 theme-color min-h-30" htmlFor="default">Date<span className='text-[#C00000]'>*</span></label>
                                                        <input
                                                            id="default"
                                                            name="sgTechTVPublishDate"
                                                            className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                                            type="date"
                                                            value={moment(this.state.sgTechTVItem.sgTechTVPublishDate).format("yyyy-MM-DD")}
                                                            onChange={(event) => this.handleChange(event)}
                                                            onBlur={() => this.validateField("sgTechTVPublishDate")}
                                                        />
                                                        <div>
                                                            <ValidationText error={this.state.validState.error.sgTechTVPublishDate} />
                                                        </div>
                                                    </div>
                                                    <div className=' xl:col-span-6 col-span-6 w-full max-lg:p-0'>
                                                        <label className="block text-xl font-normal mb-3 theme-color min-h-30" htmlFor="default">Time <span className='text-[#C00000]'>*</span></label>
                                                        <TimePicker
                                                            identity="PublishTime"
                                                            setTime={this.setTime.bind(this)}
                                                            value={this.state.sgTechTVItem.sgTechTVPublishTime}
                                                        />
                                                        <ValidationText error={this.state.validState.error.sgTechTVPublishTime} />

                                                    </div>
                                                </div>
                                                <div className='grid grid-cols-12 mt-7 gap-6 items-center w-full max-lg:grid-cols-1'>
                                                    <div className=' xl:col-span-12 col-span-12  pr-3 w-full'>
                                                        {this.state.sgTechTVItem.isSchedule === true ?
                                                            <p className='text-xl font-normal mb-3 theme-color'>
                                                                Scheduled for {moment(this.state.sgTechTVItem.sgTechTVPublishDate).format("ddd, DD MMM yyyy")} at {(this.state.sgTechTVItem.sgTechTVPublishTime)}.
                                                            </p>
                                                            : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className='xl:col-span-4  col-span-4'>
                                    <div className="2xl:col-span-4 lg:col-span-4 col-span-12">
                                        <ImageCropperWithUpload
                                            key="Main"
                                            height={460}
                                            width={814}
                                            isCheckValidation={true}
                                            MaxFileSize={2097152}
                                            MaxFileSizeMessage={"2MB"}
                                            onSaveImage={this.saveMainImage}
                                            imageIdentity="SGTechTV"
                                            intitImage={this.state.sgTechTVItem.uploadThumbnailPath}
                                            aspactRatio={550 / 260}
                                            uploadBtn={"Upload Thumbnail"}
                                            dimensionText={"(Dimension: 1280px by 720px Maximum Size: 1MB)"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Footer Button End*/}
                <div className="flex flex-wrap justify-between space-x-10 mt-12">
                    <div>
                        <button className="w-32 px-7 py-2 btn-sm btn-gray text-lg text-white" onClick={() => this.back()} >Back</button>
                    </div>
                    <div>
                        {this.state.isLoading === true || this.state.isUploading === true ? <ButtonLoader /> :
                            <>
                                <button
                                    className="w-40 px-5 mr-16 py-2 btn-sm btn-lighblue text-lg text-white"
                                    onClick={() => this.addEditSGTechTv(1)}
                                >
                                    Save as Draft
                                </button>
                                {this.state.sgTechTVItem.isPublishNow && this.state.sgTechTVItem.isPublishNow === true ?
                                    (<button
                                        className="w-32 px-7 py-2 btn-sm btn-red text-lg text-white"
                                        onClick={() => this.addEditSGTechTv(6)}
                                    >
                                        Publish
                                    </button>)
                                    :
                                    (<button className="w-32 px-7 py-2 btn-sm btn-red text-lg text-white"
                                        onClick={() => this.addEditSGTechTv(11)}
                                    >
                                        Schedule
                                    </button>)
                                }
                            </>}
                    </div>
                </div>
                {/*Footer Button End*/}
            </div>
        )
    }
}
